import api, { ApiResponse, QueryPayload, QueryResponse, WhereCondition } from './api';

export interface Page {
  id: string;
  workspace_id: string;
  fb_page_id: string;
  name: string;
  category?: string;
  about?: string;
  picture_url?: string;
  cover_url?: string;
  website?: string;
  fan_count?: number;
  verification_status?: string;
  is_published?: boolean;
  instagram_account_id?: string | null;
  instagram_username?: string | null;
  metadata?: Record<string, unknown>;
  last_synced_at?: string;
  created_at: string;
  updated_at: string;
}

export interface PageFilters {
  search?: string;
  offset?: number;
  limit?: number;
}

export interface QueryResult<T> {
  data: T[];
  total: number;
}

function buildWhereCondition(filters: PageFilters): WhereCondition | undefined {
  const conditions: WhereCondition[] = [];

  if (filters.search) {
    conditions.push({ page: { name: { op: 'ilike', value: `%${filters.search}%` } } });
  }

  return conditions.length > 0 ? { $and: conditions } : undefined;
}

export const pagesService = {
  query: async (filters: PageFilters = {}): Promise<QueryResult<Page>> => {
    const payload: QueryPayload = {
      where: buildWhereCondition(filters),
      offset: filters.offset ?? 0,
      limit: filters.limit ?? 100,
      order_by: 'page.name',
      order: 'asc',
    };

    const response = await api.post<QueryResponse<Page>>('/pages/query', payload);
    return {
      data: response.data.data,
      total: response.data._meta?.total ?? 0,
    };
  },

  getById: async (id: string): Promise<Page> => {
    const response = await api.get<ApiResponse<Page>>(`/pages/${id}`);
    return response.data.data!;
  },

  /**
   * Sync pages from Facebook for an ad account
   */
  syncFromFacebook: async (adAccountId: string): Promise<Page[]> => {
    const response = await api.post<ApiResponse<Page[]>>(`/pages/sync/${adAccountId}`);
    return response.data.data || [];
  },
};
